import axios from 'axios'
import Env from './env'

const uploadApiMap = {
  development: 'http://image-test.mini1.cn/api/image/uploadCommon',
  test: 'http://image-test.mini1.cn/api/image/uploadCommon',
  production: 'https://image-upload2.mini1.cn/api/image/uploadCommon'
}

// const mapCoverApi = 'https://shequ.mini1.cn:8081/miniw/map/?time=1603956669&uin=1001&ver=0.43.5&apiid=1&json=1&cmd=getMapDownloadUrl&token=606ba157a6f1c649878a181d5f6a4a41&is_https=1&wid='

const mapCoverApi = 'https://shequ.mini1.cn:8081/miniw/map/?time=1603956669&uin=1001&ver=0.43.5&apiid=1&json=1&act=getMapDownloadUrl&auth=read&is_https=1&wid='
const getMapidToCover = (wid) => {
  return new Promise(async (resolve, reject) => {
    const resp = await axios.get(mapCoverApi + wid)
    if (resp.status === 200 && resp.data && resp.data.root && resp.data.thumb_md5) {
      const url = resp.data.root.replace('http', 'https') + resp.data.thumb_md5 + '.png'
      resolve(url)
    } else {
      reject()
    }
  })
}

// 图片上传服务
const updateImage = async (blob) => {
  const param = new FormData() // 创建form对象
  param.append('file', blob)// 通过append向form对象添加数据
  param.append('image', blob)
  param.append('platform', 'miniworldstory')
  param.append('token', 'Hec3vcBvhkXcujsBcAq5gy8NaA9tChOT')

  const config = {
    headers: { 'Content-Type': 'multipart/form-data' }
  } // 添加请求头
  const response = await axios.post(uploadApiMap[Env.env || 'production'], param, config)
  const img = response.data.data.image.server_url
  return img
}

// 图片转base64
const drawBase64Image = (img) => {
  const canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  const dataURL = canvas.toDataURL('image/png')
  return dataURL
}
// 获取url地址图片base64
const getBase64Image = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = url + '?v=' + Math.random() // 处理缓存
    image.crossOrigin = '*' // 支持跨域图片
    image.onload = () => {
      const base64 = drawBase64Image(image)
      resolve(base64)
    }
    image.onerror = reject
  })
}

export default {
  updateImage,
  getBase64Image,
  getMapidToCover
}
